/*
 * File: Support.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on June 13, 2024 at 9:21 AM
 * Copyright © 2024 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 30, 2025 at 3:24 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Constants
import { mediumBreakpoint, mobileBreakpoint } from '../../../styles/constants';


/**
 * Styles
 */

export const Wrapper = styled.div`
	width: 100%;
	height: 100%;
	padding: 20px 0px 50px 0px;
	margin: 0 auto;

	@media only screen and (min-width: ${mediumBreakpoint}em) {
		padding: 80px 0px 50px 0px;
	}
`;

export const Header = styled.div`
	display: flex;
	align-items: start;
	flex-direction: column;
	gap: 20px;

	h1 {
		flex-grow: 1;
	}
	@media only screen and (min-width: ${mobileBreakpoint}em) {
		flex-direction: row;
		align-items: center;
	}
`;

export const FeatureSection = styled.div`
	padding: 50px 0px 0px;

	h3 {
		margin: 0px 0px 20px;
	}
`;

export const PromptContainer = styled.div`
	display: flex;
	flex-wrap: wrap;
	gap: 10px;
`;

export const ResourcesCollection = styled.div`
	display: grid;
	grid-gap: 20px;
	grid-template-columns: repeat(4, 1fr);
`;

export const PromptPlaceholder = styled.div`
	border-radius: 20px !important;
	padding: 8px 18px;
`;

export const FeedActionBar = styled.div`
	position: relative;
	padding: 0px 0px 6px;
	display: flex;
	gap: 0px;
	margin: -10px 0px 0px -10px;
`;
